const URL = {
  API: 'api/back',
  API_COMPTE: 'api/back/compte',
  API_CONFIG: 'api/back/configuration',
  API_ACHAT: 'api/back/achat',
  API_GPAO: 'api/back/gpao',
  API_CRM: 'api/back/crm',
  API_RH: 'api/back/rh',
  AGENDA: 'api/back/agenda',
};

export default URL;
